"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["QUOTE"] = "QUOTE";
    PolicyStatus["DECLINED_QUOTE"] = "DECLINED_QUOTE";
    PolicyStatus["REFERRED_QUOTE"] = "REFERRED_QUOTE";
    PolicyStatus["SUSPENDED_QUOTE"] = "SUSPENDED_QUOTE";
    PolicyStatus["POLICY"] = "POLICY";
    PolicyStatus["REFERRED_POLICY"] = "REFERRED_POLICY";
    PolicyStatus["SUSPENDED_POLICY"] = "SUSPENDED_POLICY";
    PolicyStatus["SUSPENDED_QUOTE_PROP"] = "SUSPENDED_QUOTE_PROP";
    PolicyStatus["QUOTE_ON_POLICY"] = "QUOTE_ON_POLICY";
    PolicyStatus["CANCELLED_POLICY"] = "CANCELLED_POLICY";
    PolicyStatus["CANCELLED_QUOTE"] = "CANCELLED_QUOTE";
    PolicyStatus["UNKNOWN"] = "UNKNOWN";
})(PolicyStatus || (PolicyStatus = {}));
exports.default = PolicyStatus;
